const newsLetterData = [
    {
        id: '1007',
        title: 'New Screening Room',
        date: '2021-02-09T00:54:42.6459343',
        genre: '',
        htmlContent: '/images/newScreeningRoom.jpeg',
        textContent: '',
        format: 'image'

    }, 
    {
        id: '1006',
        title: 'HALLMARK TV SVOD LAUNCHES IN THE U.K',
        date: '2020-08-14T14:54:42.6459343',
        genre: '',
        htmlContent: '/images/0814News.png',
        textContent: '',
        format: 'articleLink',
        newsLetterLink: 'https://worldscreen.com/tveurope/2020/08/14/hallmark-tv-svod-launches-in-the-u-k/'
    },
    {
        id: '1005',
        title: 'Jewels in the Crown Media International Distribution Catalog',
        date: '2020-07-27T14:54:42.6459343',
        genre: '',
        htmlContent: '/images/screenShot2020-07-27.png',
        textContent: '',
        format: 'articleLink',
        newsLetterLink: 'https://newsletters.worldscreen.com/screenings/worldscreenings_crownmedia-2020-07-21.html'
    },
    {
        id: '1004',
        title: 'New Releases: Romantic Comedies',
        date: '2020-05-19T14:54:42.6459343',
        genre: 'Romance',
        htmlContent: '/images/CMID_NEW-RELEASE_MAY_ROMANCE_flat.jpg',
        textContent: '',
        format: 'image'
    }, 
    {
        id: '1003',
        title: 'New Trailer: An Eduacation In Murder',
        date: '2020-04-13T14:54:42.6459343',
        genre: 'Mystery',
        htmlContent: './images/CMID_NEW-RELEASE_APRIL_revised.jpg',
        textContent: '',
        format: 'image',

    },
    {
        id: '1002',
        title: 'We Need A Little Christmas',
        date: '2020-03-24T14:54:42.6459343',
        genre: 'Christmas',
        htmlContent: 'https://player.vimeo.com/video/400325322?app_id=122963&wmode=opaque',
        textContent: "Following an overwhelmingly positive response to last weekend's holiday movie marathon, Hallmark Channel is debuting a second movie spectacular so viewers cozied up at home can enjoy the Hallmark holiday movies they know and love. Kicking off Friday, March 27 and running through Sunday, March 29, the next movie marathon, a response to a call from fans for a dedicated lineup of feel-good movies, include “Christmas at the Plaza,” “Mingle All the Way,” “Switched for Christmas,” “Write Before Christmas,” and many more.This past weekend, Hallmark Channel in the USA featured a special holiday marathon, “We Need a Little Christmas,” featuring a 24/7 lineup of “Countdown to Christmas” movies starring fan favorites Torrey DeVitto, Chad Michael Murray, Jill Wagner, Ryan Paevey, Jesse Metcalfe, and more.",
        format: 'video',

    },
    {
        id: '1001',
        title: 'Holiday Performance 2019',
        date: '2020-01-31T14:54:42.6459343',
        genre: 'Christmas',
        htmlContent: '/images/CMID_NEWSLETTER_CHRISTMAS_h.jpg',
        textContent: '',
        format: 'image',

    },
   
    

]

export default newsLetterData;